import ULayoutDefault from './Default';
import ULayoutWithout from './Without';

export const layouts = [
  ULayoutDefault,
  ULayoutWithout,
];
